// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","grey-font-color":"#000000","grey-body":"#5e5e5e","grey-medium":"#5e5e5e","blue":"#00afef"};